export default __webpack_public_path__ + "static/media/16.66e4567c.jpg";